import { IconProps } from "@assets";

const Rays = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg width="56" height="21" viewBox="0 0 56 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M28.5 14.5V2M44.5 19.5L54 10M11.5 19.5L1.5 10"
                stroke={props.color ?? "#4278BD"}
                strokeWidth="3"
                strokeLinecap="round"
            />
        </svg>
    );
};

const Box = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg width="80" height="55" viewBox="0 0 80 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 46V24.5L11.2157 3.30382C11.692 2.20849 12.7726 1.5 13.9669 1.5H66.0331C67.2274 1.5 68.308 2.20849 68.7843 3.30382L78 24.5V46C78 49.866 74.866 53 71 53H9C5.13401 53 2 49.866 2 46Z"
                fill="#F0F7FA"
            />
            <path
                d="M2 24.5V46C2 49.866 5.13401 53 9 53H71C74.866 53 78 49.866 78 46V24.5M2 24.5H21H28.5L30.4686 29.2426C33.8519 37.3933 45.3649 37.4853 48.878 29.3898L51 24.5H59H78M2 24.5L11.2157 3.30382C11.692 2.20849 12.7726 1.5 13.9669 1.5H66.0331C67.2274 1.5 68.308 2.20849 68.7843 3.30382L78 24.5"
                stroke={props.color ?? "#4278BD"}
                strokeWidth="3"
            />
            <path d="M64.5 7.5H16.5L11.5 19H69L64.5 7.5Z" fill="#9DBAE0" />
            <path
                d="M3.5 45.5H76.5V46.5C76.5 49.2614 74.2614 51.5 71.5 51.5H8.5C5.73857 51.5 3.5 49.2614 3.5 46.5V45.5Z"
                fill="#9DBAE0"
            />
        </svg>
    );
};

const Inbox = ({ ...props }: IconProps): JSX.Element => {
    return (
        <div className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
            <Rays color={props.color} />
            <div className="my-2">
                <Box color={props.color} />
            </div>
        </div>
    );
};

export default Inbox;
